// extracted by mini-css-extract-plugin
export default {"fieldRoot":"FieldSingleDatePicker_fieldRoot__KcOfL","labelDisabled":"FieldSingleDatePicker_labelDisabled__9rRSc","mobileMargins":"FieldSingleDatePicker_mobileMargins__zVaHy"};